import React from "react";
import { useTranslation } from "react-i18next";

import { Skeleton } from "@common/skeleton";
import { Props } from "./types";
import styles from "./styles.scss";

function Status(_: Props) {
  const { t } = useTranslation();

  return (
    <div className={styles.status}>
      <Skeleton className={styles.square} />
      <Skeleton className={styles.paragraph} />
    </div>
  );
}

export { Status };
